import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { COMPONENT_LIST_INIT_SORT } from "../constants";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
/** Initial state for secrets table filter */
export const initFilter = {
    secret_liveness: "ALL",
    service: "",
    endpoint: "",
    hide_triaged: true,
};
/** Initial state for secrets table sort */
export const initSort = {
    property: "status",
    reverse: true,
};
/** Initial state for secrets table pagination */
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: {},
    focusedRow: null,
};
const secretsSlice = createSlice({
    name: "secrets",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.id] = {
                    pagination: initPagination,
                    sortBy: COMPONENT_LIST_INIT_SORT,
                };
            }
            else {
                delete state.expandedRows[action.payload.id];
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "secrets");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
    },
});
export const secretsReducer = secretsSlice.reducer;
export const { filterUpdated, sortUpdated, paginationUpdated, expandedRowsUpdated, focusedRowUpdated, } = secretsSlice.actions;
export const selectFilter = (state) => state.report.secrets.filter;
export const selectSort = (state) => state.report.secrets.sort;
export const selectPagination = (state) => state.report.secrets.pagination;
export const selectExpandedRow = (state, id) => state.report.secrets.expandedRows[id] !== undefined;
export const selectFocusedRow = (state) => state.report.secrets.focusedRow;
export * as default from "./secretsSlice";
//# sourceMappingURL=secretsSlice.js.map